export class ToggleNavbarDropdownEvent extends Event {
	isOpen: boolean;
	constructor(isOpen: boolean, eventInitDict?: EventInit) {
		super("-fellow-toggle-navbar-dropdown", eventInitDict);
		this.isOpen = isOpen;
	}
}

// Augmenting the WindowEventMap interface makes `addEventListener` infer the event type correctly
declare global {
	interface WindowEventMap {
		"-fellow-toggle-navbar-dropdown": ToggleNavbarDropdownEvent;
	}
}
